import { Deal } from 'app/models/dto/deal.model';
import { DocumentCategory } from 'app/models/dto/document-category.model';
import { Document } from 'app/models/dto/document.model';
import { DocumentRequirementRequest, RemainingDocumentRequirement } from 'app/models/document-requirement/document-requirement.model';

export class GetDealDocumentRequirements {
	static readonly type = '[DealDocuments] GetDealDocumentRequirements';
	constructor(public deal: Deal, public loanProductId: number) {}
}

export class ClearDealDocumentRequirements {
	static readonly type = '[DealDocuments] ClearDealDocumentRequirements';
	constructor() {}
}

export class SetDocumentRequirementsMet {
	static readonly type = '[DealDocuments] SetDocumentRequirementsMet';
	constructor(public dealId: number) {}
}

export class AddDocumentCategory {
	static readonly type = '[DealDocuments] AddDocumentCategory';
	constructor(public dealId: number, public documentCategory: DocumentCategory) {}
}

export class AttachDealDocument {
	static readonly type = '[DealDocuments] AttachDealDocument';
	constructor(public dealId: number, public document: Document, public requirementGroup: string) {}
}

export class AttachAdvancedDealDocument {
	static readonly type = '[DealDocuments] AttachAdvancedDealDocument';
	constructor(public dealId: number, public document: Document) {}
}

export class DetachDealDocument {
	static readonly type = '[DealDocuments] DetachDealDocument';
	constructor(public dealId: number, public document: Document, public requirementGroup: string) {}
}

export class UploadDealDocument {
	static readonly type = '[DealDocuments] UploadDealDocument';
	constructor(
    public file: File,
    public borrowerId: number,
    public dealId: number,
    public category: string,
    public requirementGroup: string
  ) {}
}

// Advanced Deal Documents
export class GetAdvancedDocumentRequirements {
	static readonly type = '[DealDocuments] GetAdvancedDocumentRequirements';
	constructor(public dealId: number) {}
}

export class PatchDealDocument {
	static readonly type = '[DealDocuments] PatchDealDocument';
	constructor(public dealId: number, public document: Document) {}
}

export class GetAdvancedDealDocuments {
	static readonly type = '[DealDocuments] GetAdvancedDealDocuments';
	constructor(public dealId: number) {}
}

export class AdvancedDealDocumentPost {
  static readonly type = '[DealDocuments] AdvancedDealDocumentPost';
  constructor(public file: File, public formData: FormData) {}
}

export class ClearDealDocumentStatus {
  static readonly type = '[DealDocuments] ClearDealDocumentStatus';
  constructor(public dealId: number, public documentId: number) {}
}

export class ReviewDealDocument {
  static readonly type = '[DealDocuments] ReviewDealDocument';
  constructor(public dealId: number, public documentId: number) {}
}

export class RejectDealDocument {
  static readonly type = '[DealDocuments] RejectDealDocument';
  constructor(public dealId: number, public documentId: number, public rejectionReason: string) {}
}

export class PostDocumentRequirements {
  static readonly type = '[Documents] PostDocumentRequirement';
  constructor(
    public dealId: number,
    public documentRequirements: DocumentRequirementRequest
  ) { }
}

export class DeleteDocumentRequest {
  static readonly type = '[Documents] DeleteDocumentRequest';
  constructor(
    public dealId: number,
    public documentRequirement: RemainingDocumentRequirement
  ) { }
}
